import { z } from '../../../zod';

export const PageInvoiceSettingsInputValidationSchema = z
  .object({
    bankDetails: z.string().nullish(),
    additionalInformation: z
      .object({
        enabled: z.boolean().nullish(),
        title: z.string().nullish(),
        message: z.string().nullish(),
      })
      .nullish(),
    dueDays: z
      .object({
        enabled: z.boolean().nullish(),
        days: z.number().nullish(),
      })
      .nullish(),
  })
  .meta({
    id: 'PageInvoiceSettingsInput',
    description: 'Invoice configuration settings.',
    example: {
      bankDetails: 'Account: 12345678, Sort code: 00-00-00',
      additionalInformation: {
        enabled: true,
        title: 'Payment terms',
        message: 'Payment is due within 30 days of invoice date.',
      },
      dueDays: {
        enabled: true,
        days: 30,
      },
    },
  });
